import { NgModule } from '@angular/core';
import { FormStoreDirective } from './directive/form-store.directive';

@NgModule({
  declarations: [FormStoreDirective],
  exports: [FormStoreDirective],
  imports: []
})
export class NgcStoreModule {}
